import { Controller } from "stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      group: 'shared',
      animation: 150,
      onEnd: this.end.bind(this)
    })
  }

  end(event) {
    let data = new FormData()
    data.append("position", event.newIndex + 1)

    Rails.ajax({
      url: event.item.dataset.dragUrl,
      type: 'PATCH',
      data: data
    })
  }
}
